// extracted by mini-css-extract-plugin
export var dropdownContainer = "_r4-0";
export var leftAlign = "_r4-4";
export var listItem = "_r4-2";
export var listItemWrapper = "_r4-1";
export var operationText = "_r4-3";